import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'availability'})
export class AvailabilityPipe implements PipeTransform {

 
  constructor(private sanitizer: DomSanitizer) {}

  transform(id: number, role = 'client', quantity = 0, custom = ''): any {

    if (!id) {
      return '';
    }

    

    if (+id === 6) { // automatic

      if (role === 'client_b2b') {
        if (quantity <= 0) {
          return '<span class="red">'+ $localize `brak na magazynie` + '</span>';
        } else if (quantity <= 9) {
          // return '<span class="yellow">'+ $localize `mniej niż 10` + '</span>';
          return '<span class="yellow">'+ quantity + '</span>';
        } else if (quantity >= 10) {
          return '<span class="green">'+ $localize `więcej niż 10` + '</span>';
        } else {
          return '<span class="red">'+ $localize `brak informacji` + '</span>';
        }
      } else {
        if (quantity <= 0) {
          return '<span class="red">'+ $localize `brak na magazynie` + '</span>';
        } else if (quantity <= 9) {
          return '<span class="yellow">'+ $localize `mało na magazynie` + '</span>';
        } else if (quantity >= 10) {
          return '<span class="green">'+ $localize `dostępny` + '</span>';
        } else {
          return '<span class="red">'+ $localize `brak informacji` + '</span>';
        }
      }
    } else {
      switch (+id) {
        case 1: {
          return $localize `dostępny`;
        }
        case 2: {
          return $localize `na zamówienie`;
        }
        case 3: {
          return $localize `mało na magazynie`;
        }
        case 4: {
          return $localize `brak na magazynie`;
        }
        case 5: {
          return custom;
        }
        default: {
          return $localize `brak informacji`;
        }
      }
    }
  
    return '';
  }
}
